// Autopilot 需求狀態 enum + label,對齊後端 sonice-inner-system src/lib/autopilot/constants.ts。
// WorkItemDetailDrawer.jsx(單張工作項目的 AI 修復 tab)跟 AutopilotProjectPanel.jsx(專案層級
// 部署面板)都要顯示同一組狀態,曾經各寫一份導致改一邊漏改另一邊,統一抽這裡。
//
// pending_review / mr_opened / rejected 是已停用的提案覆議機制留下的值,單一入口(lead 直推 main)
// 模式下不會再產生,留著只是舊資料相容。

export const AUTOPILOT_STATUS_LABEL = {
  running: '處理中',
  committed: '已改完',
  deployed: '已部署',
  failed: '失敗',
  pending_review: '等待覆議',
  mr_opened: '待合併',
  rejected: '已拒絕',
};
